//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'category'
let resource_name = 'categoría'
let resource_name_plural = 'categorias'

let state = {
  categories: []
}

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/categories`, {params: params.params || {}})
      if(res.data.success) {
        if (!params.soft) {
          commit('setItems', res.data.resource.map(c => {
            c.error = false
            return c
          }))
        }

        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      if(res.data.success && params.callback) {
        commit('pushCategory', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if(res.data.success && params.callback) {
        commit('replaceCategory', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, {data: params})
      if(res.data.success && params.callback) {
        commit('removeCategory', params)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  },
  async parent ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/setParent`, params)
      if(res.data.success) {
        if (params.callback)
          params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  }
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state.categories = items
  },
  pushCategory (state, category) {
    state.categories.push(category)
  },
  replaceCategory (state, category) {
    let index = state.categories.findIndex(p => p.category_id == category.category_id)
    if (index >= 0) {
      state.categories.splice(index, 1, category)
    }
  },
  removeCategory (state, category) {
    let index = state.categories.findIndex(p => p.category_id == category.category_id)
    if (index >= 0) {
      state.categories.splice(index, 1)
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
